// Axios
import axios from "axios";

// Toast
import { toast } from 'react-toastify';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Export
import { jsPDF } from "jspdf";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import html2canvas from "html2canvas";

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

// Stores
import DocumentStore from '../mobx/stores/DocumentStore';
import StoreStore from '../mobx/stores/StoreStore';
import AppStore from '../mobx/stores/AppStore';

const populates = "populate[0]=images&populate[1]=dealer&populate[2]=creator_user&populate[3]=store&populate[4]=guarantee_sertificate";

const getDocuments = async () => {
    const documentsData = DocumentStore.documents;
    const storeId = localStorage.getItem('storeId');

    if (DocumentStore.loadingItemStatus) {
        return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
    }

    if (documentsData.page > documentsData.pageCount) {
        return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
    }

    DocumentStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.document}?filters[dealer][0]=${Helpers.getUserData().dealer.id}&filters[store][1]=${storeId}&pagination[page]=${documentsData.page}&pagination[pageSize]=25&sort=createdAt:desc&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((document: any) => {
            if (DocumentStore.documentDatas[document.id] === undefined) {
                DocumentStore.addDocumentData(document.id, {
                    id: document.id,
                    ...document.attributes
                })
            }

            if (DocumentStore.documents.content[document.id] === undefined) {
                DocumentStore.addDocument(document.id, {
                    id: document.id,
                    ...document.attributes
                })
            }
        });

        DocumentStore.setPaginationData(documentsData.page + 1, response.data.meta.pagination.pageCount);
    } catch (error) {
        console.log('getDocuments:', error);
    }

    DocumentStore.setLoadingItemStatus(false);
};

const getDocument = async (id: number) => {
    const storeId = localStorage.getItem('storeId');

    DocumentStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.document}?filters[id][0]=${id}&filters[dealer][1]=${Helpers.getUserData().dealer.id}&filters[store][2]=${storeId}&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((document: any) => {
            if (DocumentStore.documentDatas[document.id] === undefined) {
                DocumentStore.addDocumentData(document.id, {
                    id: document.id,
                    ...document.attributes
                })
            }
        });
    } catch (error) {
        console.log('getDocument:', error);
    }

    DocumentStore.setLoadingItemStatus(false);
};

const sendMailDocument = async (data: any, zipBlob: any, fileName: any) => {
    const formData = new FormData();
    formData.append('files', zipBlob, `${fileName}.zip`);
    formData.append('data', JSON.stringify(data));

    const axiosOptions = {
        headers: {
            Authorization: `Bearer ${Helpers.getUserData().token}`,
            "Content-Type": "multipart/form-data",
        }
    };

    AppStore.resetLoadingPercent();
    AppStore.setLoadingStatus(true);

    axiosOptions['onUploadProgress'] = (progressEvent: any) => {
        let { loaded, total } = progressEvent;
        const percent: any = (loaded / total) * 100;
        AppStore.setLoadingPercent(percent.toFixed(0))

        if (percent === 100) {
            AppStore.setLoadingStatus(false);
        }
    }

    try {
        await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.sendMailDocument}`, formData, axiosOptions);
    } catch (error) {
        console.error('sendMailDocument', error);
        AppStore.setLoadingStatus(false);
    }
};

const createDocumentStepOne = async (values: any) => {
    AppStore.setTransactionStatus(true);

    try {
        const response = await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.createDocumentStepOne}`,
            {
                data: {
                    ...values,
                }
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        if (!response.data.status) {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        AppStore.setTransactionStatus(false);

        return response.data;
    } catch (error) {
        console.log('createDocumentStepOne:', error);
        AppStore.setTransactionStatus(false);
    }
}

const createDocument = async (values: any) => {
    AppStore.setTransactionStatus(true);

    try {
        const storeId = localStorage.getItem('storeId');

        const formData = new FormData();
        formData.append('data', JSON.stringify({
            store: storeId,
            ...values
        }));

        const images = values.images;
        delete values.images;

        if (images !== undefined) {
            Helpers.objectToArray(images).forEach((photo: any) => {
                formData.append("images", photo);
            })
        }

        const axiosOptions: any = {
            headers: {
                Authorization: `Bearer ${Helpers.getUserData().token}`,
                "Content-Type": "multipart/form-data",
            }
        }

        let progressStatus = false;
        if (images !== undefined) {
            if (images.length !== undefined) {
                progressStatus = true;
            }
        }

        if (progressStatus) {
            AppStore.resetLoadingPercent();
            AppStore.setLoadingStatus(true);

            axiosOptions['onUploadProgress'] = (progressEvent: any) => {
                let { loaded, total } = progressEvent;
                const percent: any = (loaded / total) * 100;
                AppStore.setLoadingPercent(percent.toFixed(0))

                if (percent === 100) {
                    AppStore.setLoadingStatus(false);
                }
            }
        }

        const response = await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.document}`, formData, axiosOptions);

        if (response.data.status) {
            toast(Helpers.translation(response.data.message));
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        AppStore.setLoadingStatus(false);
        AppStore.setTransactionStatus(false);
        return response.data;
    } catch (error) {
        console.log('createDocument:', error);
        AppStore.setLoadingStatus(false);
        AppStore.setTransactionStatus(false);
    }
}

const deleteDocument = async (documentId: number) => {
    DocumentStore.setLoadingItemStatus(true);

    try {
        confirmAlert({
            title: Helpers.translation('warning'),
            message: Helpers.translation('delete-alert-text'),
            buttons: [
                {
                    label: Helpers.translation('yes'),
                    onClick: async () => {
                        const response = await axios.delete(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.document}/${documentId}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                                }
                            }
                        );

                        if (response.data.status) {
                            toast(Helpers.translation(response.data.message));
                        } else {
                            confirmAlert({
                                title: Helpers.translation('error'),
                                message: Helpers.translation(response.data.message),
                                buttons: [
                                    {
                                        label: Helpers.translation('i-got-it'),
                                    }
                                ]
                            });
                        }
                    }
                },
                {
                    label: Helpers.translation('no'),
                }
            ]
        });
    } catch (error) {
        console.log('deleteDocument:', error);
    }

    DocumentStore.setLoadingItemStatus(false);
};

const searchDocuments = async (resetSearchRecord: boolean = false) => {
    const filters = DocumentStore.searchFilterText;

    if (filters !== "") {
        if (resetSearchRecord) {
            DocumentStore.resetSearchDocuments();

        }

        const searchDocumentsData = DocumentStore.searchDocuments;

        if (DocumentStore.loadingItemStatus) {
            return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
        }

        if (searchDocumentsData.page > searchDocumentsData.pageCount) {
            return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
        }

        DocumentStore.setLoadingItemStatus(true);

        try {
            const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.document}?pagination[page]=${searchDocumentsData.page}&pagination[pageSize]=25&sort=createdAt:desc${filters}&${populates}`,
                {
                    headers: {
                        Authorization: `Bearer ${Helpers.getUserData().token}`,
                    }
                }
            );

            response.data.data.forEach((document: any) => {
                if (DocumentStore.documentDatas[document.id] === undefined) {
                    DocumentStore.addDocumentData(document.id, {
                        id: document.id,
                        ...document.attributes
                    })
                }

                if (DocumentStore.searchDocuments.content[document.id] === undefined) {
                    DocumentStore.addSearchDocument(document.id, {
                        id: document.id,
                        ...document.attributes
                    })
                }
            });

            DocumentStore.setSearchPaginationData(searchDocumentsData.page + 1, response.data.meta.pagination.pageCount);
        } catch (error) {
            console.log('searchDocuments:', error);
        }

        DocumentStore.setLoadingItemStatus(false);
    }
};

// Logo'yu base64 formatına çeviren fonksiyon
const returnPageLogo = async (logoUrl) => {
    if (!logoUrl) return null;

    const response = await fetch(logoUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

// Sarmaşık çerçeve görselini base64 formatına çeviren fonksiyon
const returnBorderImage = async (borderUrl) => {
    if (!borderUrl) return null;

    const response = await fetch(borderUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

const returnPageContent = (documentData: any, dealerData: any, guaranteePageData: any, page: number, content: any, logoBase64: string, borderBase64: string, lastPage: boolean) => {
    return `
        <div style="
            width: 100%; 
            height: 100%; 
            padding: 0; 
            background-image: url('${borderBase64}'); 
            background-size: 100% 100%; 
            background-repeat: no-repeat;
            box-sizing: border-box;
        ">
            <div style="
                width: calc(100% - 40px); 
                height: calc(100% - 40px); 
                margin: 20px; 
                padding-left: ${guaranteePageData.padding_left};
                padding-right: ${guaranteePageData.padding_right};
                padding-top: ${guaranteePageData.padding_top};
                padding-bottom: ${guaranteePageData.padding_bottom};
                border-radius: 8px; 
                box-shadow: 0 0 10px rgba(0,0,0,0.1);
                box-sizing: border-box;
            ">
                <div style="display: flex; flex-direction: column; align-items: center;">
                    ${logoBase64 !== null ? `<img src="${logoBase64}" style="width: 360px;" />` : ""}
                </div>

                ${page === 1 ? `<div style="width: 100%; text-align: center; font-size: 3rem; font-weight: 700;">${guaranteePageData.title}</div>` : ``}

                ${page === 1 ? `
                    <div style="margin-bottom: 20px; font-size: 14px;">
                        <div style="display: flex; justify-content: space-between; margin-top: 20px;">
                            <div style="width: 48%;">
                                <p style="text-decoration-line: underline; font-weight: 700; font-size: 1.25rem">SİSTEM BİLGİLERİ</p>
                                <div style="display: flex;"><b>Sistem Tipi:</b><p style="margin-left: 5px;">${documentData.system_type}</p></div>
                                <div style="display: flex;"><b>Regülatör No:</b><p style="margin-left: 5px;">${documentData.regulator_number}</p></div>
                                <div style="display: flex;"><b>Montaj Tarihi:</b><p style="margin-left: 5px;">${documentData.montage_date}</p></div>
                                <div style="display: flex;"><b>Garanti Başlangıç Tarihi:</b><p style="margin-left: 5px;">${documentData.guarantee_start_date}</p></div>
                                <div style="display: flex;"><b>Garanti Bitiş Tarihi:</b><p style="margin-left: 5px;">${documentData.guarantee_finish_date}</p></div>
                                <div style="display: flex;"><b>Arac Km:</b><p style="margin-left: 5px;">${documentData.vehicle_kilometer}</p></div>
                            </div>

                            <div style="width: 48%;">
                                <p style="text-decoration-line: underline; font-weight: 700; font-size: 1.25rem">MÜŞTERİ / ARAÇ BİLGİLERİ</p>
                                <div style="display: flex;"><b>Adı / Soyadı:</b><p style="margin-left: 5px;">${documentData.customer_name_surname}</p></div>
                                <div style="display: flex;"><b>Şasi No:</b><p style="margin-left: 5px;">${documentData.vehicle_chassis_number}</p></div>
                                <div style="display: flex;"><b>Marka-Tip-Model:</b><p style="margin-left: 5px;">${documentData.vehicle_brand + ' - ' + documentData.vehicle_type + ' - ' + documentData.vehicle_model}</p></div>
                                <div style="display: flex;"><b>Plaka:</b><p style="margin-left: 5px;">${documentData.vehicle_plate}</p></div>
                                <div style="display: flex;"><b>Telefon/Mail:</b><p style="margin-left: 5px;">${documentData.customer_phone + ' / ' + documentData.customer_email}</p></div>
                                <div style="display: flex;"><b>Adres:</b><p style="margin-left: 5px;">${documentData.customer_address}</p></div>
                            </div>
                        </div>

                        <div>
                            <p style="text-decoration-line: underline; font-weight: 700; font-size: 1.25rem">BAYİ BİLGİLERİ</p>
                            <div style="display: flex;"><b>Bayi:</b><p style="margin-left: 5px;">${dealerData.title}</p></div>
                            <div style="display: flex;"><b>Bayi Adresi:</b><p style="margin-left: 5px;">${dealerData.address}</p></div>
                            <div style="display: flex;"><b>Bayi Telefonu:</b><p style="margin-left: 5px;">${dealerData.phone}</p></div>
                        </div>
                    </div>
                ` : ``}

                <div style="font-size: 15px;">${content}</div>

                ${lastPage ? `
                    <div style="display: flex; justify-content: space-around; align-items: flex-start; margin-top: 20px;">
                        <div style="margin-left: 10px; margin-right: 10px; flex: 1; text-align: center;">
                            Bayi Kaşe İmza

                            <div style="width: 100%; height: 120px; margin-top: 20px; border: 1px solid #000;">
                            </div>
                        </div>

                        <div style="margin-left: 10px; margin-right: 10px; flex: 1; text-align: center;">
                            Müşteri
                        </div>

                        <div style="margin-left: 10px; margin-right: 10px; flex: 1; text-align: center;">
                            Distribütör
                        </div>
                    </div>
                ` : ``}
            </div>
        </div>
    `;
};

// PDF ve ZIP dosyasını indiren fonksiyon
const downloadDocumentData = async (type: string, id: number, sendMail?: boolean) => {
    AppStore.setTransactionStatus(true);
    const documentData = DocumentStore.documentDatas[id];

    const storeId: any = localStorage.getItem('storeId');
    const storeData = StoreStore.stores[storeId];
    const guaranteeSertificateData = storeData.guarantee_sertificates.data.filter((sertificate: any) => {
        return sertificate.attributes.type === type;
    }).map((sertificate: any) => {
        return {
            id: sertificate.id,
            ...sertificate.attributes
        }
    })[0];

    console.log(guaranteeSertificateData);

    // Logo URL'sini al ve base64 olarak dönüştür
    const logoUrl = guaranteeSertificateData.logo.data !== null ? Helpers.getMediumImageUrl(guaranteeSertificateData.logo.data.attributes) : undefined;
    const logoBase64: any = logoUrl ? await returnPageLogo(logoUrl) : null;

    // Sarmaşık çerçeve görselini base64 olarak dönüştür
    const borderUrl = guaranteeSertificateData.border.data ? Helpers.getMediumImageUrl(guaranteeSertificateData.border.data.attributes) : undefined;
    const borderBase64: any = borderUrl ? await returnBorderImage(borderUrl) : null;

    const pages: any = [];

    const dealerData = {
        id: documentData.dealer.data.id,
        ...documentData.dealer.data.attributes
    };

    for (let i = 1; i <= guaranteeSertificateData.page_count; i++) {
        const contents = guaranteeSertificateData.Pages.filter((pageData) => pageData.page === i);
        const pageContent = contents.map((content) => {
            return `
                ${content.title !== null ? `<strong>${content.title}</strong>` : ""}
                ${content.contents}
            `;
        }).join('');

        const isLastPage = (i === guaranteeSertificateData.page_count);
        pages.push(returnPageContent(documentData, dealerData, guaranteeSertificateData, i, pageContent, logoBase64, borderBase64, isLastPage));
    }

    // PDF oluşturma işlemi (A4 boyutunda)
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

    for (let i = 0; i < pages.length; i++) {
        const pageContent = pages[i];

        // Sayfayı geçici olarak DOM'a ekleme
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = pageContent;
        tempDiv.style.width = "1024px"; // Genişliği 1024 piksel olarak ayarlıyoruz
        document.body.appendChild(tempDiv);

        // Sayfayı görüntüye çevirip PDF'ye ekleme
        const canvas = await html2canvas(tempDiv, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");

        // Sıkıştırılmış resim oluşturma
        const compressedCanvas = document.createElement("canvas");
        const ctx: any = compressedCanvas.getContext("2d");

        const img = new Image();
        img.src = imgData;
        await new Promise((resolve: any) => {
            img.onload = () => {
                compressedCanvas.width = img.width; // Orijinal genişlik
                compressedCanvas.height = img.height; // Orijinal yükseklik
                ctx.drawImage(img, 0, 0);
                resolve();
            };
        });

        const compressedImgData = compressedCanvas.toDataURL("image/jpeg", 0.9); // %90 kalite ile JPEG olarak kaydet

        // A4 boyutuna göre konumlandırma
        const imgWidth = 210; // A4 genişliği (mm)
        const pageHeight = 297; // A4 yüksekliği (mm)
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Resmin yüksekliği

        // Resmi A4 sayfasına ekleme
        pdf.addImage(compressedImgData, "PNG", 0, 0, imgWidth, imgHeight);
        document.body.removeChild(tempDiv);

        // Yeni PDF sayfasına geçiyoruz, son sayfa dışında
        if (i < pages.length - 1) pdf.addPage();
    }

    // PDF'yi blob olarak kaydedip zip dosyasına ekliyoruz
    const pdfBlob = pdf.output("blob");
    const zip = new JSZip();
    zip.file(`Garanti Belgesi.pdf`, pdfBlob);

    // Görselleri indirip zip dosyasına ekliyoruz
    if (documentData.images.data !== null) {
        const imageUrls = documentData.images.data.map((image) => {
            return Helpers.getBiggestImageUrl(image.attributes);
        });

        for (let i = 0; i < imageUrls.length; i++) {
            const url = imageUrls[i];
            const response = await fetch(url);
            const blob = await response.blob();
            zip.file(`image${i + 1}.jpg`, blob);
        }
    }

    // Zip dosyasını oluşturup indirme işlemini başlatıyoruz
    zip.generateAsync({ type: "blob" }).then(async (content) => {
        if (sendMail) {
            await sendMailDocument({
                senderData: {
                    host: guaranteeSertificateData.email_sender_host,
                    port: guaranteeSertificateData.email_sender_port,
                    secure: guaranteeSertificateData.email_sender_secure,
                    auth: {
                        user: guaranteeSertificateData.email_sender_auth,
                        pass: guaranteeSertificateData.email_sender_pass,
                    },
                },
                emailData: {
                    to: documentData.customer_email,
                    from: guaranteeSertificateData.email_from,
                    subject: guaranteeSertificateData.email_subject,
                    html: guaranteeSertificateData.email_content
                }
            }, content, documentData.vehicle_plate);

            await sendMailDocument({
                senderData: {
                    host: guaranteeSertificateData.email_sender_host,
                    port: guaranteeSertificateData.email_sender_port,
                    secure: guaranteeSertificateData.email_sender_secure,
                    auth: {
                        user: guaranteeSertificateData.email_sender_auth,
                        pass: guaranteeSertificateData.email_sender_pass,
                    },
                },
                emailData: {
                    to: guaranteeSertificateData.info_email,
                    from: guaranteeSertificateData.info_email_from,
                    subject: guaranteeSertificateData.info_email_subject,
                    html: guaranteeSertificateData.info_email_content
                }
            }, content, documentData.vehicle_plate);
        } else {
            saveAs(content, documentData.vehicle_plate + ".zip");
        }
    });

    AppStore.setTransactionStatus(false);
};

const exportHelpers = {
    getDocuments,
    getDocument,
    createDocumentStepOne,
    deleteDocument,
    searchDocuments,
    createDocument,
    downloadDocumentData
}

export default exportHelpers;